
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interview/shizutetsu-sosarea",
      function () {
        return require("private-next-pages/interview/shizutetsu-sosarea.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interview/shizutetsu-sosarea"])
      });
    }
  